import React, {useState, useEffect} from 'react';
import './style.css';
import { useNavigate, useLocation } from 'react-router-dom';
import ContentHeading from '../../components/contentHeading/contentHeading';
import ContentHeadingButton from '../../components/contentHeading/contentHeadingButton';
import TableView from '../../components/tableView/tableView';
import TableViewPaginationControls from '../../components/tableViewPaginationControls/tableViewPaginationControls'
import { authFetch } from '../../components/authFetch/authFetch'
import { Throbber } from '../../components/throbber/throbber'
import { SlEnvolope } from "react-icons/sl";
import { Link } from 'react-router-dom';

const SegmentDetail = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [segment, setSegment] = useState({ segment_name: "", contacts: [] });
    const [statusState, setStatusState] = useState('loading');

    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const rowsPerPage = 40;

    const handleGoBack = () => {
        navigate('/audience/');
    };

    const queryParams = new URLSearchParams(location.search);
    const query_segment_id = queryParams.get("id");

    const headings = {
        Profile: 'Profile',
        Email: 'Email',
        Phone: 'Phone',
        ProfileCreated: 'Profile Created',
        LastUpdated: 'Last Updated',
        Location: 'Location',
    };

    const fetchPageData = (new_page) => {
        console.log(new_page);
        setStatusState("loading");
        authFetch({
            apiMethod: "GET",
            endpoint: "/audience/segments/detail",
            queryParams: {
                segment_id: query_segment_id,
                limit: rowsPerPage,
                offset: (new_page - 1) * rowsPerPage,
            },
            onDataLoaded: (data) => {
                setStatusState("success");
                setSegment(formatSegmentData(data?.segment));
                setCurrentPage(new_page)
                setTotalPages(Math.ceil(data.pagination?.total / rowsPerPage) || 1);
            },
            onErrorResponse: () => {
                setStatusState("error");
                console.log("error");
            },
        });
    }

    const formatSegmentData = (data) => {
        console.log("Raw segment data:", data);
    
        // Ensure data exists and is an object
        if (!data || typeof data !== "object") {
            console.error("formatSegmentData received invalid data:", data);
            return { segment_name: "Unknown", contacts: [] };
        }
    
        // Ensure `contacts` is defined and is an array
        const raw_contacts = Array.isArray(data.contacts) ? data.contacts : [];
        
        const contacts = raw_contacts.map((contact) => ({
            Profile: `${contact.first_name || ""} ${contact.last_name || ""}`.trim(),
            Email: contact.email || "N/A",
            Phone: contact.phone || "N/A",
            ProfileCreated: contact.created_at || "N/A",
            LastUpdated: contact.updated_at || "N/A",
            Location: [contact.city, contact.region, contact.country].filter(Boolean).join(", "),
        }));
    
        return {
            segment_name: data?.name || "Unknown",
            contacts: contacts
        };
    };

    useEffect(() => {
        fetchPageData(currentPage);
    }, []);

    return (
        <div className='audience-home-container'>
            {statusState == "loading" && (
                <div className="throbber-overlay">
                    <Throbber />
                </div>
            )}
            <ContentHeading action={
                 <ContentHeadingButton handleContentHeadingButton={handleGoBack} buttonStyleClass="back-button" buttonName="Go Back" />
            } heading={segment?.segment_name} />

            <TableView headings={headings} data={segment?.contacts}/>
            <TableViewPaginationControls currentPage={currentPage} totalPages={totalPages} onPageChange={fetchPageData} />
        </div>
    );
};

export { SegmentDetail };
